module.exports = {
  annotate: require(77).annotate,
  Module: require(80),
  Injector: require(79)
};
